// @generated by TypeGen from LogbookApi/DeviceDebugTraceApi - DO NOT EDIT

import type { IDebugDatabaseUploadRequest, IDebugDatabaseUploadResponse, IDebugNMEAUploadResponse, IDebugUploadResponse } from "../LogbookApp/DeviceDebugTraceApi"
import type { IAppResponse } from "../LogbookApp/Routes"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface DeviceDebugTraceApiEndpoints {
  "POST /api/debug/database": {
    params: {};
    query: {};
    request: IDebugDatabaseUploadRequest;
    response: IDebugDatabaseUploadResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/debug/log": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: {};
  };
  "POST /api/debug/nmea": {
    params: {};
    query: {};
    request: never;
    response: IDebugNMEAUploadResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/debug/upload": {
    params: {};
    query: {};
    request: never;
    response: IDebugUploadResponse;
    targets: ApiTarget[];
    permission: {};
  };
}

export const deviceDebugTraceApiEndpoints = {
  "POST /api/debug/database": { targets: ["app"], permission: { ship: IShipUserLevel.viewCurrent } },
  "POST /api/debug/log": { targets: ["app"], permission: {} },
  "POST /api/debug/nmea": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
  "POST /api/debug/upload": { targets: ["app"], permission: {} },
} as const;

export class DeviceDebugTraceApi {
  constructor(private client: ApiClient) {}

  debugDatabase = {
    upload: (a: ApiArgs<DeviceDebugTraceApiEndpoints, "POST /api/debug/database">) => ({
      call: (): Promise<IDebugDatabaseUploadResponse> => {
        assertTarget(this.client, "POST /api/debug/database", deviceDebugTraceApiEndpoints["POST /api/debug/database"].targets);
        return this.client.call<IDebugDatabaseUploadResponse>("POST /api/debug/database", a);
      },
      url: (): string => this.client.url("POST /api/debug/database", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.viewCurrent,
    }),
  };

  debugLog = {
    upload: (a: ApiArgs<DeviceDebugTraceApiEndpoints, "POST /api/debug/log">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/debug/log", deviceDebugTraceApiEndpoints["POST /api/debug/log"].targets);
        return this.client.call<IAppResponse>("POST /api/debug/log", a);
      },
      url: (): string => this.client.url("POST /api/debug/log", a),
      available: (_user?: ApiUser): boolean => true,
    }),
  };

  debugNmea = {
    upload: (a: ApiArgs<DeviceDebugTraceApiEndpoints, "POST /api/debug/nmea">) => ({
      call: (): Promise<IDebugNMEAUploadResponse> => {
        assertTarget(this.client, "POST /api/debug/nmea", deviceDebugTraceApiEndpoints["POST /api/debug/nmea"].targets);
        return this.client.call<IDebugNMEAUploadResponse>("POST /api/debug/nmea", a);
      },
      url: (): string => this.client.url("POST /api/debug/nmea", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.primary,
    }),
  };

  debugUpload = {
    upload: (a: ApiArgs<DeviceDebugTraceApiEndpoints, "POST /api/debug/upload">) => ({
      call: (): Promise<IDebugUploadResponse> => {
        assertTarget(this.client, "POST /api/debug/upload", deviceDebugTraceApiEndpoints["POST /api/debug/upload"].targets);
        return this.client.call<IDebugUploadResponse>("POST /api/debug/upload", a);
      },
      url: (): string => this.client.url("POST /api/debug/upload", a),
      available: (_user?: ApiUser): boolean => true,
    }),
  };
}
